var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('PercentageGraph',{attrs:{"visible":"","data":_vm.graphData,"title":_vm.graphTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }